import 'babel-polyfill'
import _ from 'underscore'
import deepclone from 'underscore.deepclone'
import Vue from 'vue'
import App from './App'
// import ElementUI from 'element-ui'
// import VCharts from 'v-charts'
// import VueRouter from 'vue-router'
import '@/index/plugin/socket'
import '@/index/plugin/axios'
import '@/index/plugin/bus'
import '@/index/plugin/alarm'
import Session from '@/index/plugin/session'
import Local from '@/index/plugin/local'
import '@/index/assets/svg-icons'
import '@/index/components'
import '@/index/filter'
// import '@/index/mock/register'
import util from '@/index/libs/util.js'
import store from '@/index/store/index'
// 菜单和路由设置
import router from './router'
import menuHeader from '@/index/menu/header'
import menuAside from '@/index/menu/aside'
import { frameInRoutes } from '@/index/router/routes'
// import { Popconfirm } from 'element-ui'
// import VeLine from 'v-charts/lib/line.common'
import VeLine from 'v-charts/lib/line'
Vue.component(VeLine.name, VeLine)
Vue.use(Session)
Vue.use(Local)

_.mixin(deepclone)
// Vue.use(VeLine)
// Vue.use(ElementUI)
// Vue.use(VueRouter)
// Vue.use(Popconfirm)
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.prototype.$env = process.env.NODE_ENV
Vue.prototype.$baseUrl = process.env.BASE_URL

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    // 处理路由 得到每一级的路由设置
    this.getAllPageFromRoutes()
    // 设置顶栏菜单
    this.$store.commit('d2adminMenuHeaderSet', menuHeader)
    // 设置侧边栏菜单
    this.$store.commit('d2adminMenuAsideSet', menuAside)
  },
  mounted () {
    // 获取并记录用户 UA
    this.$store.commit('d2adminUaGet')
    // 展示系统信息
    util.showInfo()
    // 用户登陆后从数据库加载一系列的设置
    this.$store.commit('d2adminLoginSuccessLoad')
  },
  methods: {
    /**
     * 处理路由 得到所有的页面
     */
    getAllPageFromRoutes () {
      const pool = []
      const push = function (routes) {
        routes.forEach(route => {
          if (route.children) {
            push(route.children)
          }
          const { meta, name, path } = route
          pool.push({ meta, name, path })
        })
      }
      push(frameInRoutes)
      this.$store.commit('d2adminPagePoolSet', pool)
    }
  }
}).$mount('#app')
